import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';

@Component({
  standalone: true,
  selector: 'app-home',
  imports: [CommonModule],
  template: `
<h4 class="mb-3">Verfügbare Festivals</h4>
<div class="row g-3">
  <div class="col-12 col-md-6 col-lg-4" *ngFor="let f of festivals()">
    <div class="card h-100 shadow-sm" (click)="goFestival(f.id)" style="cursor:pointer;">
      <img *ngIf="f.imageUrl; else placeholder" [src]="f.imageUrl" class="card-img-top" alt="{{ f.name }}" style="height:200px; object-fit:cover;">
      <ng-template #placeholder>
        <div class="d-flex align-items-center justify-content-center bg-light" style="height:200px;">
          <span class="text-secondary">Kein Bild</span>
        </div>
      </ng-template>
      <div class="card-body">
        <h5 class="card-title">{{ f.name }}</h5>
        <p class="card-text"><small class="text-muted">{{ f.id }}</small></p>
      </div>
    </div>
  </div>
</div>
  `
})
export class HomeComponent implements OnInit {
  festivals = signal<any[]>([]);

  constructor(private api: ApiService, private auth: AuthService, private router: Router) {}

  async ngOnInit() {
    this.festivals.set(await this.api.listFestivals());
  }

  goFestival(id: string) {
    this.router.navigate(['/festival', id]);
  }
}
